import type {Result, UseCase} from 'framework';
import type {BodyMeasurementsError} from '../../domain/errors';
import type {MeasurementEntryId} from '../../domain/measurement-entry';
import type {BodyMeasurementsRepository} from '../ports/body-measurements.repository';

export type DeleteMeasurementEntryInput = {
  readonly entryId: MeasurementEntryId;
};

export class DeleteMeasurementEntry implements UseCase<[DeleteMeasurementEntryInput], void> {
  constructor(private readonly repository: BodyMeasurementsRepository) {}

  execute(input: DeleteMeasurementEntryInput): Promise<Result<void, BodyMeasurementsError>> {
    return this.repository.deleteEntry(input.entryId);
  }
}
